import { dataSort } from 'dls-icons-data'
import { createIcon } from '../common'

const IconSort = /*#__PURE__*/createIcon(dataSort)
export default IconSort
